import React, { useEffect, useState } from "react";
import CalendarImg from '../../assets/images/calendar.svg';
import SelectOption from "./selectButton";
import DateRangePopUp from "./dateRangePopUp";
import moment from "moment";
import { selectedPeriod } from '../../utils/utils';
import { useSelector } from "react-redux";

export default function DateSelect({
  show,
  setShow = () => { },
  onDateRangeChange = () => { },
  selectOption,
  setSelectOption = () => { },
  setDashboardDate,
  isShow,
  onViewAll = () => { },
}) {
  const id = useSelector((state) => state.common.camp?.camp_details_id);
  const [lastSelected, setLastSelect] = useState();
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  useEffect(() => {
    if (id) {
      const period = selectedPeriod(1, "YYYY-MM-DD", "/")?.split("/");
      setSelectOption(1);
      onDateRangeChange(period[0], period[1], 1); // 1 = Today
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="w-full">
      <div className="flex flex-wrap md:justify-content-start  w-full items-center sm:items-start  md:justify-start gap-2 sm:gap-4">
        <div className="flex justify-content-center w-full md:w-auto md:block mt-0 md:mt-3">
          {!isShow && (
            <div className="flex items-center">
              <img className="" src={CalendarImg} alt="calendar" />
              <span
                className="pl-2 font-light"
                style={{
                  fontFamily: "Public Sans-500",
                }}
              >
                {selectedPeriod(selectOption, "DD MMM YYYY", " - ", [
                  date?.[0]?.startDate,
                  date?.[0]?.endDate,
                ])}
              </span>
            </div>
          )}
        </div>
        <SelectOption
          className="flex-shrink-0 flex md:justify-content-space-between w-auto ml-[-10px] mt-2 sm:ml-auto sm:mt-0 text-lg py-1 sm:text-sm "
          setValue={(e) => {
            if (e === null && selectOption === 4) return setShow(true);
            if (e == null) return;
            if (e === 5) {
              onViewAll();
              setSelectOption((prev) => {
                setLastSelect((pre) => ({ ...pre, option: prev }));
                return e;
              });
              return;
            }
            const period = selectedPeriod(e, "YYYY-MM-DD", "/")?.split("/");
            if (e !== 4) {
              onDateRangeChange(period[0], period[1], e);
            }
            setSelectOption((prev) => {
              setLastSelect((pre) => ({
                ...pre,
                option: prev,
              }));
              return e;
            });
          }}
          setShow={setShow}
          options={[
            { name: "Today", value: 1 },
            { name: "7 Days", value: 2 },
            { name: "30 Days", value: 3 },
            {
              name: (
                <div className="flex items-center justify-center gap-2 ">
                  <span className="">Select Date</span>
                  <i className="icon-calendar-time" style={{ fontSize: "18px" }} />
                </div>
              ),
              value: 4,
            },
            // {
            //   name: (
            //     <div className="flex items-center justify-center gap-2">
            //       <span>View All</span>
            //       <i className="icon-eye" style={{ fontSize: "18px" }} />
            //     </div>
            //   ),
            //   value: 5,
            // },
          ]}
          value={selectOption}
        />
      </div>

      <DateRangePopUp
        show={show}
        setShow={setShow}
        date={date}
        setDate={(data) => {
          setDate(data);
          // setDashboardDate(data);
          setLastSelect({ option: 4 });
          onDateRangeChange(
            moment(data?.[0]?.startDate).format("YYYY-MM-DD"),
            moment(data?.[0]?.endDate).format("YYYY-MM-DD"),
            selectOption
          );
          show && setShow(false);
        }}
        lastSelected={lastSelected?.option}
        setSelectOption={setSelectOption}
      />
    </div>
  );
}
